import type { IconType } from 'react-icons'

export type DueDateMacro =
  | 'Active only'
  | 'Next 30 days'
  | 'Next 3 months'
  | 'Next 12 months'
  | 'Custom date'

export const DUE_DATE_MACROS: DueDateMacro[] = [
  'Active only',
  'Next 30 days',
  'Next 3 months',
  'Next 12 months',
  'Custom date',
]

export type PostedDateMacro =
  | 'Past day'
  | 'Past week'
  | 'Past month'
  | 'Past year'
  | 'Custom date'

export const POSTED_DATE_MACROS: PostedDateMacro[] = [
  'Past day',
  'Past week',
  'Past month',
  'Past year',
  'Custom date',
]

export interface Macro<T> {
  title: T
  icon: IconType
  func: () => void
}

export interface Value {
  is_active: boolean | null
  active_after: string | null
  active_before: string | null
  published_after: string | null
  published_before: string | null
}
